import { render, staticRenderFns } from "./GestionIncidencia.vue?vue&type=template&id=6691d7e4&"
import script from "./GestionIncidencia.vue?vue&type=script&lang=js&"
export * from "./GestionIncidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports